export function escapeRegExp(input: string): string {
  return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function makeWordBoundaryRegex(literal: string, flags = "gi"): RegExp {
  const escaped = escapeRegExp(literal);
  const startsWithWord = /^\w/.test(literal);
  const endsWithWord = /\w$/.test(literal);
  const prefix = startsWithWord ? "\\b" : "";
  const suffix = endsWithWord ? "\\b" : "";
  return new RegExp(`${prefix}${escaped}${suffix}`, flags);
}

export function makeFlexibleSectionRegex(
  sectionName: string,
  flags = "gi"
): RegExp {
  const parts = sectionName.split(/(\s*[-–—,]\s*)/);

  const patternParts = parts.map((part) => {
    if (/^\s*[-–—,]\s*$/.test(part)) {
      return "\\s*[-–—,]\\s*";
    }
    return escapeRegExp(part);
  });

  const pattern = patternParts.join("");
  const startsWithWord = /^\w/.test(sectionName);
  const endsWithWord = /\w$/.test(sectionName);
  const prefix = startsWithWord ? "\\b" : "";
  const suffix = endsWithWord ? "\\b" : "";

  return new RegExp(`${prefix}${pattern}${suffix}`, flags);
}
